import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const ForeignerlevyModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const isActiveValue = watch("isActive");

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Foreigner Levy" : "Edit Foreigner Levy"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="needs-validation"
          noValidate
        >
          <div className="mt-3">
            <Input
              name="foreignWorkerCode"
              label="Foreign Worker Code"
              placeholder="Enter foreign worker code"
              type="text"
              className={`form-control ${
                errors.foreignWorkerCode ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Foreign Worker Code is required"
              labelClassName="form-label"
            />
          </div>
          <div className="mt-3">
            <Input
              name="description"
              label="Description"
              labelClassName="form-label"
              placeholder="Enter description"
              type="text"
              className={`form-control ${
                errors.description ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Description is required"
            />
          </div>
          <div className="mt-3">
            {" "}
            <Input
              name="monthlyAmount"
              label="Monthly Amount"
              labelClassName="form-label"
              placeholder="Enter monthly amount"
              type="string"
              className={`form-control ${
                errors.monthlyAmount ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Monthly Amount is required"
            />
          </div>
          <div className="mt-3">
            {" "}
            <Input
              name="dailyAmount"
              label="Daily Amount"
              labelClassName="form-label"
              placeholder="Enter daily amount"
              type="string"
              className={`form-control ${
                errors.dailyAmount ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Daily Amount is required"
            />
          </div>

          <div className="mb-3">
            <Input
              name="isActive"
              type="commonSelect"
              placeholder="Status"
              className={`form-control ${errors.isActive ? "is-invalid" : ""}`}
              label="Status"
              labelClassName="form-label"
              optionData={boolStatus}
              required={true}
              requiredMessage="Status is required"
              onChange={(selectedOption) => {
                console.log(selectedOption);
                setValue("isActive", selectedOption);
                trigger("isActive");
              }}
              defaultValue={watch("isActive")}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </div>

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

ForeignerlevyModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ForeignerlevyModal;
